import { ChangeDetectionStrategy, Component, ViewChild, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ConfirmCleanDialogComponent } from "../../components/confirm-clean-dialog/confirm-clean-dialog.component";
import { AuditScoreSummaryComponent } from "../../components/audit-score-summary/audit-score-summary.component";
import {
  AUDITOR_OPTIONS,
  COUNTRY_OPTIONS,
  LAB_PERSONNEL_COUNT_OPTIONS,
  LOCATION_OPTIONS,
  SERVICE_COMPANY_OPTIONS,
  TOTAL_WORKING_HOURS_OPTIONS,
  WORKING_HOURS_FROM_OPTIONS,
  WORKING_HOURS_TO_OPTIONS,
} from "../../data/lab-audit-lookups";
import { AuditInformation, AuditScoreRow } from "../../models/lab-audit.models";
import { LabAuditStateService } from "../../services/lab-audit-state.service";

@Component({
  selector: "app-information-tab",
  standalone: true,
  imports: [FormsModule, AuditScoreSummaryComponent, ConfirmCleanDialogComponent],
  templateUrl: "./information-tab.component.html",
  styleUrl: "./information-tab.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationTabComponent {
  @ViewChild(ConfirmCleanDialogComponent) private cleanDialog?: ConfirmCleanDialogComponent;
  readonly auditState = inject(LabAuditStateService);
  readonly auditorOptions = AUDITOR_OPTIONS;
  readonly countryOptions = COUNTRY_OPTIONS;
  readonly laboratoryPersonnelCountOptions = LAB_PERSONNEL_COUNT_OPTIONS;
  readonly locationOptions = LOCATION_OPTIONS;
  readonly serviceCompanyOptions = SERVICE_COMPANY_OPTIONS;
  readonly totalWorkingHoursOptions = TOTAL_WORKING_HOURS_OPTIONS;
  readonly workingHoursFromOptions = WORKING_HOURS_FROM_OPTIONS;
  readonly workingHoursToOptions = WORKING_HOURS_TO_OPTIONS;

  get scoreRows(): AuditScoreRow[] {
    return [
      { label: "Safety", score: this.auditState.safetyScore(), maximumScore: 80, compatibility: this.auditState.safetyCompatibility() },
      { label: "Lab Equipment", score: this.auditState.labEquipmentScore(), maximumScore: this.auditState.labEquipmentMaximum, compatibility: this.auditState.labEquipmentCompatibility() },
      { label: "Sampling (Including Record Keeping)", score: this.auditState.samplingScore(), maximumScore: 76, compatibility: this.auditState.samplingCompatibility() },
      {
        label: "Lab Testing Procedures",
        score: this.auditState.labTestingProceduresScore(),
        maximumScore: this.auditState.labTestingProceduresMaximum() || null,
        compatibility: this.auditState.labTestingProceduresCompatibility(),
      },
      { label: "Cement Job", score: this.auditState.cementJobScore(), maximumScore: 80, compatibility: this.auditState.cementJobCompatibility() },
    ];
  }

  update<K extends keyof AuditInformation>(field: K, value: AuditInformation[K]): void {
    this.auditState.updateInformation(field, value);
  }

  updatePersonnelCount(value: string | number | null): void {
    const normalized = value === "" || value === null ? null : Number(value);
    this.auditState.updateInformation("laboratoryPersonnelCount", normalized);
  }

  updateTotalWorkingHours(value: string | number | null): void {
    const normalized = value === "" || value === null ? null : Number(value);
    this.auditState.updateInformation("totalLabWorkingHours", normalized);
  }

  openCleanDialog(): void {
    this.cleanDialog?.open();
  }
}
